import { Game } from "../../model";
import apiService from "../ApiService";
import { ListSortMethod } from "./ListSortMethod";

export const getFavorites = (sortBy: ListSortMethod, page = 0, limit?: number) => {
  return apiService.get<{ games: Game[]; meta: { total: number } }>({
    path: `public/games/favorites`,
    edito: true,
    params: {
      page: `${page}`,
      sort: sortBy,
      limit,
    },
  });
};
